<template>
  <div class="group-reservation">
    <div class="group-heading">
      <div>
        <p class="eyebrow">GOLF RESERVATION</p>
        <h3>Group Reservation</h3>
      </div>
      <span class="reservation-badge">{{ form.status }}</span>
    </div>

    <div class="group-form-grid">
      <div class="form-section">
        <label>Golf club<input v-model="form.golfClub" type="text" readonly></label>
        <label>Reservation no.<input v-model="form.reservationNo" type="text" readonly></label>
        <label>No. of holes<select v-model="form.holes"><option>18</option><option>9</option></select></label>
        <label>1st course<select v-model="form.firstCourse"><option>Tee box 1</option><option>Tee box 2</option></select></label>
        <label>Event<input v-model="form.event" type="text"></label>
        <label class="tournament-field">Tournament<div><input v-model="form.tournament" type="radio" value="yes"> Yes <input v-model="form.tournament" type="radio" value="no"> No</div></label>
        <label>Reservation by<input v-model="form.reservationBy" type="text"></label>
        <label>Address<input v-model="form.address" type="text"></label>
        <label>Primary SOB<input v-model="form.primarySob" type="text" readonly></label>
        <label>Secondary SOB<input v-model="form.secondarySob" type="text" readonly></label>
        <label>Note<textarea v-model="form.note" rows="2"></textarea></label>
      </div>

      <div class="form-section">
        <label>Booking date<input v-model="form.bookingDate" type="date"></label>
        <label>2nd course<select v-model="form.secondCourse"><option>Tee box 10</option><option>Tee box 18</option></select></label>
        <label>Group customer ID<input v-model="form.groupCustomerId" type="text"></label>
        <label>Payment term<input v-model="form.paymentTerm" type="text"></label>
        <label class="full-width">Payment instruction<textarea v-model="form.paymentInstruction" rows="2"></textarea></label>
      </div>

      <div class="form-section">
        <label>Reservation type<input v-model="form.reservationType" type="text" readonly></label>
        <label>Status<input v-model="form.status" type="text" readonly></label>
        <label>Tee time<div class="time-range"><input v-model="form.teeTimeFrom" type="time"><span>to</span><input v-model="form.teeTimeTo" type="time"></div></label>
        <label>No. of flights<input v-model="form.flights" type="number" min="1"></label>
        <label>Mobile no.<input v-model="form.mobileNo" type="text"></label>
        <label>Phone no.<input v-model="form.phoneNo" type="text"></label>
        <div class="number-pair"><label>Number of player<input v-model="form.playerCount" type="number" min="0"></label><label>Number of member<input v-model="form.memberCount" type="number" min="0"></label></div>
        <label>Group folio no.<input v-model="form.groupFolioNo" type="text"></label>
        <label class="requests-field">Guest request (per flight)<span><input v-model="form.caddy" type="checkbox"> Caddy&nbsp;&nbsp;<input v-model="form.cart" type="checkbox"> Cart</span></label>
      </div>
    </div>

    <div class="payment-panel">
      <label class="payment-toggle"><input v-model="form.paymentByGroup" type="checkbox"> Payment by group</label>
      <div v-if="form.paymentByGroup" class="payment-grid">
        <label>Group rate code<input v-model="form.groupRateCode" type="text"></label>
        <label>Rate amount<input v-model="form.rateAmount" type="number" min="0"></label>
        <label>Deposit<input v-model="form.deposit" type="number" min="0"></label>
        <label>Payment date<input v-model="form.paymentDate" type="date"></label>
        <label>Action<select v-model="form.action"><option>Name List</option><option>Confirm</option></select></label>
        <label>Action date<input v-model="form.actionDate" type="date"></label>
      </div>
    </div>

    <div class="group-actions">
      <button type="button" class="btn-secondary" @click="$emit('back')">Back to calendar</button>
      <button type="button" class="btn-secondary">Delete</button>
      <button type="button" class="btn-primary" @click="form.status = 'Reserved'">Save reservation</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GroupReservation',
  props: {
    golfClub: {
      type: String,
      default: 'Perfect Golf Course'
    },
    bookingDate: {
      type: String,
      default: '2026-07-22'
    }
  },
  data() {
    return {
      form: {
        golfClub: this.golfClub,
        reservationNo: '0000009872',
        holes: '18',
        firstCourse: 'Tee box 1',
        secondCourse: 'Tee box 10',
        event: 'BRI Prioritas Golf Tournament',
        tournament: 'yes',
        reservationBy: 'Jimmy Santoso',
        address: 'Jl. Bougenville, Cluster Jasmine, PIK, Jakarta',
        primarySob: 'GROUP',
        secondarySob: 'RESERVATION',
        note: 'Visitor player',
        bookingDate: this.bookingDate,
        groupCustomerId: 'TN010',
        paymentTerm: '03',
        paymentInstruction: 'All charge will paid by group',
        reservationType: 'Half Day Morning',
        status: 'Reserved',
        teeTimeFrom: '05:30',
        teeTimeTo: '10:42',
        flights: 80,
        mobileNo: '0999 8877 6655',
        phoneNo: '',
        playerCount: 0,
        memberCount: 0,
        groupFolioNo: '',
        caddy: true,
        cart: false,
        paymentByGroup: true,
        groupRateCode: 'PIGA J1',
        rateAmount: 884000,
        deposit: 0,
        paymentDate: this.bookingDate,
        action: 'Name List',
        actionDate: this.bookingDate
      }
    }
  }
}
</script>

<style scoped>
.group-reservation { padding: 22px 24px 26px; }.group-heading { display: flex; align-items: center; justify-content: space-between; margin-bottom: 18px; }.eyebrow { margin: 0 0 3px; color: #6c8398; font-size: 11px; font-weight: 700; letter-spacing: 1.2px; }.group-heading h3 { margin: 0; color: #284a63; font-size: 20px; }.reservation-badge { padding: 5px 10px; border-radius: 12px; color: #277253; font-size: 12px; font-weight: 700; background: #e4f6ec; }
.group-form-grid { display: grid; grid-template-columns: 1.2fr 1fr 1fr; gap: 20px; padding: 18px; border: 1px solid #d8e3e9; border-radius: 6px; background: #fafcfd; }.form-section { display: flex; flex-direction: column; gap: 9px; }.form-section > label, .payment-grid label, .number-pair label { display: grid; grid-template-columns: 118px minmax(0, 1fr); align-items: center; gap: 8px; color: #546a7c; font-size: 12px; font-weight: 700; }.form-section input, .form-section select, .form-section textarea, .payment-grid input, .payment-grid select { width: 100%; min-height: 31px; padding: 6px 8px; border: 1px solid #cedae2; border-radius: 3px; color: #334c60; font-size: 12px; font-weight: 400; background: #fff; }.form-section input[readonly] { color: #697c8b; background: #edf1f4; }.form-section textarea { resize: vertical; }.tournament-field input, .requests-field input { width: auto; min-height: auto; margin: 0 4px 0 0; }.time-range { display: flex; align-items: center; gap: 5px; }.time-range input { min-width: 0; }.number-pair { display: grid; grid-template-columns: 1fr 1fr; gap: 9px; }.number-pair label { grid-template-columns: 1fr; gap: 4px; }
.payment-panel { margin-top: 14px; padding: 14px 16px; border: 1px solid #c7dbe7; border-radius: 5px; background: #f8fcff; }.payment-toggle { color: #38576d; font-size: 13px; font-weight: 700; }.payment-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 10px 20px; margin-top: 13px; }.group-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 18px; }.group-actions button { min-height: 34px; padding: 7px 12px; border-radius: 4px; font-size: 13px; }.btn-primary { border: 1px solid #187c5d; color: #fff; background: #198f69; }.btn-secondary { border: 1px solid #cfd9e0; color: #49677f; background: #fff; }
@media (max-width: 980px) { .group-form-grid { grid-template-columns: 1fr; }.payment-grid { grid-template-columns: 1fr; } }.group-reservation { padding: 16px; }
</style>



// WEBPACK FOOTER //
// GroupReservation.vue?19ed2991